import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { Account } from "../server/supabase-account-service";
import { SupabaseAccountService } from "../server/supabase-account-service";

export const useAccount = (): UseSupabaseLoaderState<Account> => {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseAccountService(supabase).get(account_id);
    if (error) {
      throw new Error(`Failed to load account: ${error.message}`);
    }

    return data;
  }, []);
};
